import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function ConversionRateOptimization() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = true;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Turn More Visitors into Customers with Strategic CRO
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We optimize every step of the user journey to increase
                conversions and revenue. Our data-driven approach eliminates
                friction points and improves{" "}
                <Link to="/uiux/">
                  user experience
                </Link>
                . This makes sure that visitors take meaningful actions on your
                website.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title="Conversion Rate Optimization (CRO) for Higher Engagement and Better Results"
            subtitle={
              <div>
                At Riches Media Digital, we implement CRO strategies that drive
                measurable improvements. Our team refines landing pages and
                tests elements that influence user behavior. We make sure that
                every visitor finds the right information and completes the
                desired action. Our structured approach improves engagement and
                increases conversions.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/marketing (7).json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            invert={!dark}
            step1={"User Behavior Analysis and Funnel Optimization"}
            step1description={
              "We analyze visitor behavior and identify drop-off points. Our team optimizes conversion funnels to improve navigation. We also refine page structures to create a smoother user journey."
            }
            step2={"Landing Page Testing and Element Refinement"}
            step2description={
              "We test landing page variations and analyze their impact. Our team refines headlines and call-to-action (CTA) placements. We also work on visual hierarchy to improve user engagement."
            }
            step3={"A/B Testing and Performance Tracking"}
            step3description={
              "We run A/B tests and compare different elements for effectiveness. Our team tracks key performance indicators and gathers data-driven insights. We also refine strategies based on test outcomes."
            }
            step4={"Form Optimization and Lead Capture Improvement"}
            step4description={
              "We simplify form fields and remove unnecessary steps. Our team improves form placements and refines CTA wording. We also optimize input validation to reduce errors and increase completion rates."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our CRO Services"}
            title1={"Higher Conversion Rates"}
            subtitle1={
              "We optimize website elements to drive more sign-ups and purchases. A structured approach improves visitor-to-customer conversion."
            }
            title2={"Better User Experience"}
            subtitle2={
              "We simplify navigation and refine interactions. This reduces bounce rates and improves engagement."
            }
            title3={"Data-Driven Decision Making"}
            subtitle3={
              "We track performance metrics and analyze visitor behavior. A/B testing helps refine elements based on real-time insights."
            }
            title4={"Stronger Lead Generation"}
            subtitle4={
              "We optimize lead forms and improve CTA visibility. This increases submission rates and attracts more qualified leads."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title="Turn Website Traffic into Revenue with Precision CRO"
            subtitle="At Riches Media Digital, we optimize conversion pathways to turn passive visitors into engaged customers. Our CRO strategies eliminate decision roadblocks and refine user interactions. We optimize page layouts and streamline navigation. This ensures that every visitor experiences a seamless journey that leads to conversions. Be it increasing form submissions or boosting eCommerce sales, we implement data-backed refinements that drive measurable business growth."
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/cn-new.jpg")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            invert={!dark}
            title1={"Strategic CRO Implementation"}
            title2={"Data-Backed A/B Testing"}
            title3={"Landing Page Optimization Experts"}
            title4={"Improved User Flow and Navigation"}
            title5={"Higher Lead and Sales Conversions"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is Conversion Rate Optimization (CRO)?"
            a1="CRO improves website performance by increasing the percentage of visitors who complete a desired action. It involves A/B testing and landing page refinement. It further encircles form optimization to remove friction and improve conversions."
            q2="Why is CRO important for my business?"
            a2="CRO increases the effectiveness of existing traffic and reduces customer drop-offs. A well-optimized website improves engagement and drives higher revenue. Businesses that invest in CRO gain better returns without increasing ad spend."
            q3="How long does it take to see CRO results?"
            a3="CRO delivers faster results compared to long-term strategies like SEO. Websites start seeing improvements within four to eight weeks based on testing cycles and  <a href='https://richesmediadigital.com/end-to-end-analytics/'>data analysis</a>. Ongoing refinements lead to sustained conversion growth."
            q4="What factors affect conversion rates?"
            a4="Conversion rates depend on <a href='https://richesmediadigital.com/uiux/'>user experience</a> and page performance. Clear CTAs and strong messaging further improve the likelihood of conversion."
            q5="How do you determine which elements to test?"
            a5="We conduct user behavior analysis and heatmap tracking to identify weak points. Our team prioritizes headlines and CTA placements. We also test layout variations that influence user decisions."
            q6="How do you measure CRO success?"
            a6="CRO success is measured through conversion rate uplift and engagement growth. We track user interaction metrics and form submission rates to refine ongoing strategies."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
